export {};
import { Checkbox } from "@pacificoseguros/pixie/react/checkbox";
import React, { useCallback } from "react";
import { Row } from "../../../components/layout/flex-layout";
import { Typography } from "../../../components/typography/typography";
import { quotationPopupFormDefinition } from "../constants/form-fields-definition";
import { useQuotationPopupFormContext } from "../hooks/use-quotation-popup-form";

export const QuotationPopupTermsAndConditionsCheckboxField: React.FC = () => {
    const rhForm = useQuotationPopupFormContext();
    const { termsAndConditions } = rhForm.watch([
        quotationPopupFormDefinition.termsAndConditions.key,
    ]);
    const handleChange = useCallback((value) => {
        rhForm.setValue("termsAndConditions", value.detail, {
            shouldValidate: true,
        });
    }, []);
    return (
        <Row
            align="flex-start"
            data-testid="QuotationPopupTermsAndConditionsCheckboxField"
        >
            <Checkbox checked={termsAndConditions} handleChange={handleChange}>
                <span></span>
            </Checkbox>
            <Typography variant="grey-1">
                He leído y acepto las condiciones establecidas de las{" "}
                <Typography className="text-underline">
                    <b>POLITICAS DE PRIVACIDAD.</b>
                </Typography>{" "}
                <a
                    href="https://www.pacifico.com.pe/transparencia/politica-privacidad#privacidad"
                    target="_blank"
                    rel="noreferrer"
                >
                    <Typography variant="secondary">
                        Conoce más aquí.
                    </Typography>
                </a>
            </Typography>
        </Row>
    );
};
